Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = requiredUnless;
function requiredUnless(optionalPropName, propType) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  // eslint-disable-next-line consistent-return
  return function () {
    function validator(props, propName, componentName) {
      if (props[optionalPropName]) {
        for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          rest[_key - 3] = arguments[_key];
        }

        return propType.apply(undefined, [props, propName, componentName].concat(rest));
      }

      if (props[propName] === defaultValue || typeof props[propName] === 'undefined') {
        return new TypeError(String(componentName) + ': when ' + String(optionalPropName) + ' is not set, prop \u201C' + String(propName) + '\u201D must be present.');
      }
    }

    return validator;
  }();
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/requiredUnless.js
// module id = 258
// module chunks = 168707334958949